import { t } from "@repo/shared/i18n";
import { useEffect, useState } from "react";

interface UseDebounceOptions {
  minLength?: number;
  delay?: number;
  contextForErrorMessage?: string;
}

const useDebounce = <T,>(value: T, options: UseDebounceOptions = {}) => {
  const { minLength = 0, delay = 300 } = options;
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined,
  );
  useEffect(() => {
    const timer = setTimeout(() => {
      if (typeof value === "string") {
        if (value.length < minLength && value.length !== 0) {
          setErrorMessage(
            t("searchMinLength", {
              subject: options?.contextForErrorMessage || t("searchTerm"),
              min: minLength,
            }),
          );
          return;
        } else {
          setErrorMessage(undefined);
        }
      }
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return {
    debouncedSearchTerm: debouncedValue,
    errorMessage,
  };
};

export default useDebounce;
